import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Logo from '../logo/logo.component';
import Searches from '../searches/searches.component';
import MainMenu from '../mainmenu/mainmenu.component';
import AccountLogin from '../accountlogin/accountlogin.component';
import {getCinemaLocations} from '../../../SHARED/actions/filters.actions';
import ADRLogo from '../../resources/img/hp-site_buton-ADR-logos.png';
import { ABOUT_PROJECT } from '../../../SHARED/config/routes';

class Header extends Component {

    componentWillMount(){
        this.props.getCinemaLocations();
    }

    isLandingPage() {
        //return this.props.location.pathname === '/' ? true : false;
        return false;
    }

    aboutProject = () => {
        this.props.history.push(ABOUT_PROJECT);
    }

    render() {
        return (
            <div className="header">
                <div className="container-fluid">
                    <div className="row no-gutters">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-7">
                            <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <Logo />
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    { this.isLandingPage() ? '' : <Searches/> }
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2 ADR">
                            <img className="ADR-logo" src={ADRLogo} alt="Logo" onClick={this.aboutProject} />
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-4 col-xl-3">
                            <AccountLogin />
                        </div>
                        <div className="col-md-12">
                            { this.isLandingPage() ? '' : <MainMenu/> }
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {getCinemaLocations})(Header));



// WEBPACK FOOTER //
// ./src/FO/components/header/header.component.js